import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    NLP_DETAIL_SCORE_COLUMNS,
    renderDetailRow,
} from '../TracePanelShared';

const scoreAverage = (value) => {
  if (value || value === 0) {
    return Number(value).toLocaleString(undefined, {
      style: 'percent',
      minimumFractionDigits: 2
    });
  } else {
    return 'unknown';
  }
};

const renderIntent = (intent, index, intentsLabel, scoresLabel) => {
  return (
    <React.Fragment key={`${intent.intent}-${index}`}>
      {index === 0 && renderDetailRow({
        content: `${intentsLabel}:`,
        trailing: <span>{scoresLabel}:</span>,
        alignItems: 'flex-end',
      })}
      {renderDetailRow({
        content: `#${intent.intent.replaceAll('_', ' ')}`,
        trailing: scoreAverage(intent.score),
        alignItems: 'flex-end',
      })}
    </React.Fragment>
  );
};

const ConversationItemIntents = (props) => {
  const { t } = useTranslation();
  const intentsLabel = t('Intents');
  const scoresLabel = t('Scores');

  return (
    <React.Fragment>
      {props.intents ? (
        props.intents.slice(0, 3).map((intent, index) => {
          return renderIntent(intent, index, intentsLabel, scoresLabel);
        })
      ) : (
        renderDetailRow({
          content: t('No intents'),
          trailingColumns: NLP_DETAIL_SCORE_COLUMNS,
          alignItems: 'flex-end',
        })
      )}
    </React.Fragment>
  );
};

export default ConversationItemIntents;
